import { useEffect } from 'react';

/** Injects a JSON-LD structured data script into <head>, cleaned up on unmount. */
export default function JsonLd({ id, data }: { id: string; data: object }) {
  useEffect(() => {
    const el = document.createElement('script');
    el.type = 'application/ld+json';
    el.id = `jsonld-${id}`;
    el.text = JSON.stringify(data);
    document.head.appendChild(el);
    return () => { document.getElementById(`jsonld-${id}`)?.remove(); };
  }, [id, data]);
  return null;
}
